/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_payment } from "../../App/actions/paymentActions";
import { post_activities } from "../../App/actions/activities";
import { set_value_user } from "../../App/actions/authActions";

/*PICTURE*/
import icon_gift from "../../Assets/svg/gift.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const PriceNavButton = ({
  language,
  set_value_payment,
  set_value_user,
  post_activities,
}) => {
  const toggle_modal_payment = () => {
    set_value_payment({
      key: "is_able_to_greeting_page",
      value: false,
    });
    set_value_user("modal_payment_universal", true);

    post_activities({
      action: "open_pricing",
    });
  };

  //content
  return (
    <div className="sidebar_button vertical_center w_200 hover_lightGrey">
      <div
        role="button"
        tabIndex={0}
        onClick={toggle_modal_payment}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle_modal_payment();
          }
        }}
        className="vertical_center_child"
      >
        <div style={{ marginLeft: "20px" }}>
          <img src={icon_gift} alt="Redeem" width="35px" />
        </div>
        <div
          className="text_medium"
          style={{ marginLeft: "20px", width: "250px", color: "black" }}
        >
          {dict?.["View Plans"]?.[language]}
        </div>
      </div>
    </div>
  );
};

export default connect(null, {
  set_value_payment,
  set_value_user,
  post_activities,
})(PriceNavButton);
